import React from "react";
import { Route, Switch } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import MSFTheme from "../../../themes/MSFTheme";

import Dashboard from "./Dashboard";
import QuestionnaireList from "./Questionnaire/QuestionnaireList";
import Questionnaire from "./Questionnaire/Questionnaire";
import SurveyList from "./Survey/SurveyList";
import Survey from "./Survey/Survey";

const MSFRouter = () => (
    <ThemeProvider theme={MSFTheme}>
        <Switch>
            <Route path="/msf/surveys/:uuid" component={Survey} />
            <Route path="/msf/surveys" component={SurveyList} />
            <Route path="/msf/questionnaires/:uuid" component={Questionnaire} />
            <Route path="/msf/questionnaires" component={QuestionnaireList} />
            <Route path="/msf/" component={Dashboard} />
        </Switch>
    </ThemeProvider>
);

export default MSFRouter;
